<div class="popup__container" *ngIf="!loading">
  <div class="card shadow" [ngClass]="{'card shadow': true, 'loaded':!loading, 'disappear': disappear}">
    <div class="card-body popup__body">
      <a href="javascript: void(0);" (click)="openProduct(currentData.ProductId)">
        <img class="popup__image" [src]="getImageUrl()" />
      </a>
      <p class="card-text"><em>{{currentData.Customer}}</em> bought {{dateString}} in {{currentData.Location}}</p>
    </div>
  </div>
</div>